
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redaction/story-writing",
      function () {
        return require("private-next-pages/redaction/story-writing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redaction/story-writing"])
      });
    }
  